export enum FilterToField {
  TITLE = 'titulo',
  AUTHOR = 'autor',
  DELIVERY_DATE = 'data_entrega',
  PUBLICATION_DATE = 'data_publicacao',
  GRADE = 'nota',
  STATUS = 'status',
}
